/**
 * Max number of related items that can be added in a single add operation. Ops involving the add/removal of the
 * relatedItems are sent atomically using ContainerRuntime's OrderSequentially method which requires that total size of
 * all messages must be less than maxOpSize.Note that maxOpSize applies the JSON serialized content length which doubles
 * the original data size and includes other data related with the op.
 */
export const MAX_RELATED_ITEMS_PER_OP = 100;

/** The maximum length that the input can be that is used for validation using decorators. */
export const MAX_INPUT_LENGTH = 65535;
